import pwcLogoLogin from "@/assets/images/pwc-logo-login.svg";

interface ErrorPageProps {
  code: string;
  title: string;
  description: string;
}

export function ErrorPage({ code, title, description }: ErrorPageProps) {
  const base = import.meta.env.BASE_URL;

  return (
    <div className="min-h-screen bg-white flex flex-col relative">
      {/* Simple Header with Logo */}
      <header className="h-[72px] border-b border-[rgba(0,0,0,0.09)] flex items-center px-8 shrink-0">
        <a href={base} className="flex items-center">
          <img src={pwcLogoLogin} alt="PwC" className="h-[42px] w-[234px]" />
        </a>
      </header>

      <main className="flex-1 flex flex-col items-center justify-center gap-6 p-[100px]">
        {/* Illustration container — 892px wide, centered */}
        <div className="flex flex-col items-center" style={{ width: 892 }}>
          <img
            src={`${base}images/icon-error.svg`}
            alt="Internal Server Error"
            className="object-contain"
          />
        </div>

        {/* Text block — column, center-aligned */}
        <div className="flex flex-col items-center gap-[24px]">
          <div className="flex flex-col items-center gap-[4px]">
            <span className="text-display font-bold text-black">{code}</span>
            <p className="text-display-giant font-normal text-black  mt-[4px]">{title}</p>
          </div>
          <p className="text-h2 font-normal text-center text-[#000000]" style={{ width: 973 }}>
            {description}
          </p>
        </div>
      </main>
    </div>
  );
}
